import React from 'react';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Footer() {
  const {
    t,
    lang
  } = useLanguage();
  const nav = t('footer.nav') as string[];
  const legalLinks = t('footer.legal_links') as string[];
  const navLinks = [{
    label: nav[0],
    href: '/#inicio'
  }, {
    label: nav[1],
    href: '/#que-son'
  }, {
    label: nav[2],
    href: '/#donde'
  }, {
    label: nav[3],
    href: '/#retiros'
  }, {
    label: nav[4],
    href: '/#sobre-mi'
  }, {
    label: nav[5],
    href: '/#contacto'
  }];
  return <footer className="text-cream border-t border-forest-light/20 relative overflow-hidden" style={{
    backgroundColor: '#0f2318'
  }} data-id="element-248">
      {/* Subtle decorative top accent */}
      <div className="h-[2px] bg-gradient-to-r from-transparent via-gold/50 to-transparent" data-id="element-249"></div>

      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-16 md:py-20" data-id="element-250">
        {/* Top: brand */}
        <div className="flex flex-col items-center text-center mb-14 md:mb-16" data-id="element-251">
          <img src="https://cdn.magicpatterns.com/uploads/aJgjT628oMXg8QNdmtF8wc/logo_constelaciones.png" alt="Georgina Constelaciones" className="h-24 md:h-28 w-auto mb-6 brightness-110" data-id="element-252" />
          <p className="font-serif text-gold-light italic max-w-2xl text-balance px-2" style={{
          fontSize: '18px',
          lineHeight: 1.5
        }} data-id="element-253">
            {t('footer.tagline')}
          </p>
        </div>

        {/* Middle: grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-12 mb-14" data-id="element-254">
          {/* Navigation */}
          <div className="text-center sm:text-left" data-id="element-255">
            <h4 className="font-serif text-gold-light mb-5 uppercase tracking-wider" style={{
            fontSize: '15px'
          }} data-id="element-256">
              {t('footer.nav_label')}
            </h4>
            <ul className="space-y-3" data-id="element-257">
              {navLinks.map((link, i) => <li key={i} data-id="element-258">
                  <a href={link.href} className="text-cream/85 hover:text-gold transition-colors" style={{
                fontSize: '15px'
              }} data-id="element-259">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center sm:text-left" data-id="element-260">
            <h4 className="font-serif text-gold-light mb-5 uppercase tracking-wider" style={{
            fontSize: '15px'
          }} data-id="element-261">
              {t('nav.contact')}
            </h4>
            <ul className="space-y-3 text-cream/85" data-id="element-262">
              <li data-id="element-263">
                <a href="tel:671636887" className="inline-flex items-center gap-3 hover:text-gold transition-colors" style={{
                fontSize: '15px'
              }} data-id="element-264">
                  <Phone className="w-4 h-4 text-gold-light flex-shrink-0" data-id="element-265" />
                  <span data-id="element-266">671 636 887</span>
                </a>
              </li>
              <li data-id="element-267">
                <a href="mailto:georginaconstelaciones@gmail.com" className="inline-flex items-center gap-3 hover:text-gold transition-colors break-all" style={{
                fontSize: '14px'
              }} data-id="element-268">
                  <Mail className="w-4 h-4 text-gold-light flex-shrink-0" data-id="element-269" />
                  <span data-id="element-270">georginaconstelaciones@gmail.com</span>
                </a>
              </li>
              <li className="inline-flex items-center gap-3" style={{
              fontSize: '15px'
            }} data-id="element-271">
                <MapPin className="w-4 h-4 text-gold-light flex-shrink-0" data-id="element-272" />
                <span data-id="element-273">Vilafranca del Penedès</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className="text-center sm:text-left sm:col-span-2 md:col-span-1" data-id="element-274">
            <h4 className="font-serif text-gold-light mb-5 uppercase tracking-wider" style={{
            fontSize: '15px'
          }} data-id="element-275">
              {t('footer.social_label')}
            </h4>
            <a href="https://www.instagram.com/georgina_constelaciones/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-5 py-3 border border-cream/25 rounded-full hover:border-gold hover:bg-gold/10 transition-all text-cream/90" data-id="element-276">
              <Instagram className="w-5 h-5 text-gold-light" data-id="element-277" />
              <span style={{
              fontSize: '14px'
            }} data-id="element-278">
                @georgina_constelaciones
              </span>
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-[1px] bg-forest-light/30 mb-8" data-id="element-279"></div>

        {/* Legal links */}
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 mb-6" style={{
        fontFamily: 'Inter, sans-serif',
        fontWeight: 300,
        fontSize: '13px'
      }} data-id="element-280">
          <a href="/aviso-legal" className="text-[#a3b596] hover:text-gold transition-colors" data-id="element-281">
            {legalLinks[0]}
          </a>
          <span className="text-[#a3b596]/40" data-id="element-282">·</span>
          <a href="/politica-privacidad" className="text-[#a3b596] hover:text-gold transition-colors" data-id="element-283">
            {legalLinks[1]}
          </a>
          <span className="text-[#a3b596]/40" data-id="element-284">·</span>
          <a href="/politica-cookies" className="text-[#a3b596] hover:text-gold transition-colors" data-id="element-285">
            {legalLinks[2]}
          </a>
        </div>

        {/* Bottom: copyright */}
        <div className="text-center text-cream/60 font-light" style={{
        fontSize: '13px'
      }} data-id="element-286">
          <p data-id="element-287">{t('footer.copy')}</p>
        </div>

        {/* Credit line */}
        <div className="text-center" style={{
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 300,
        fontSize: '11px',
        color: 'rgba(168, 184, 154, 0.5)',
        letterSpacing: '1px',
        marginTop: '12px',
        paddingBottom: '16px'
      }} data-id="element-288">
          Diseño web por{' '}
          <a href="https://www.kineticgrowthstudio.com" target="_blank" rel="noopener noreferrer" style={{
          color: 'rgba(196, 154, 74, 0.5)',
          textDecoration: 'none',
          transition: 'opacity 0.3s ease, color 0.3s ease'
        }} onMouseEnter={e => {
          e.currentTarget.style.color = '#c49a4a';
          e.currentTarget.style.opacity = '1';
        }} onMouseLeave={e => {
          e.currentTarget.style.color = 'rgba(196, 154, 74, 0.5)';
          e.currentTarget.style.opacity = '1';
        }} data-id="element-289">
            kineticgrowthstudio.com
          </a>
        </div>
      </div>
    </footer>;
}